export const approvedRecipeActions = (role, status = "Approved") => {
  if (status !== "Approved") return [];
  const canEdit = ["Owner/Admin", "Manager"].includes(role);
  return ["scale", ...(canEdit ? ["revision"] : []), ...(role === "Owner/Admin" ? ["departmentAccess"] : [])];
};

export const departmentAccessPayload = (primaryDepartmentId, sharedDepartmentIds = []) => ({
  primary_department_id: primaryDepartmentId,
  shared_department_ids: [...new Set(sharedDepartmentIds)].filter(id => id && id !== primaryDepartmentId),
});

